export enum NavigationRoutesEnum {
    HOME = '/',
    BIOGRAPHY = '/biografia',
    WORK = '/obra',
    CONTACT = '/contacto',
    ABOUT = '/acerca-de'
}